export default __webpack_public_path__ + "static/format-eksempel1-445003dfe03ca6bb841f112ea7128ae0.png";